// extracted by mini-css-extract-plugin
module.exports = {"submenuLink":"Aside_submenuLink__3unW4"};